export default {
      id: "settings-menu-usage",
      viewBox: "0 0 26.324 26.324",
      url: "/dist/svg/" + "sprite.svg#settings-menu-usage",
      toString: function () {
        return this.url;
      }
    }